import axios from '@/plugins/axios';
import SystemConst from '@/shared/system-const';
import { TableFilters } from '@/components/common/common-table-filter.component';

export default {
    namespaced: true,

    state: {
        // 一覧画面用
        /** ページ */
        pageNation: 1,

        /** 表示件数 */
        itemsPerPage: SystemConst.LIST_LINES_PER_PAGE[1],

        /** 組織ツリーのアクティブなノード */
        activeNode: [],

        /** 組織ツリーで展開されているノード */
        openNode: [],

        /** 組織ツリーのラジオボタン */
        searchMethod: SystemConst.USER_SEARCH_METHOD.ALL_USER,

        /** 組織ツリーの検索文字列 */
        searchTree: '',

        /** フィルター条件 */
        filters: {},

        /** ソートカラム */
        sortBy: [],

        /** ソート昇順、降順 */
        sortDesc: [],

        /** 登録・編集・削除画面からの遷移フラグ */
        isFromAdd: false
    },
    mutations: {
        /** セッター：state.pageNation */
        setPageNation(state: any, pageNation: number) {
            state.pageNation = pageNation;
        },

        /** セッター：state.itemsPerPage */
        setItemsPerPage(state: any, itemsPerPage: number) {
            state.itemsPerPage = itemsPerPage;
        },

        /** セッター：state.activeNode */
        setActiveNode(state: any, activeNode: string[]) {
            state.activeNode = activeNode;
        },

        /** セッター：state.openNode */
        setOpenNode(state: any, openNode: string[]) {
            state.openNode = openNode;
        },

        /** セッター：state.searchMethod */
        setSearchMethod(state: any, searchMethod: string) {
            state.searchMethod = searchMethod;
        },

        /** セッター：state.searchTree */
        setSearchTree(state: any, searchTree: string) {
            state.searchTree = searchTree;
        },

        /** セッター：state.filters */
        setFilters(state: any, filters: TableFilters) {
            state.filters = filters;
        },
        
        /** セッター：state.sortBy */
        setSortBy(state: any, sortBy: string[]) {
            state.sortBy = sortBy;
        },
        
        /** セッター：state.sortDesc */
        setSortDesc(state: any, sortDesc: boolean[]) {
            state.sortDesc = sortDesc;
        },

        /** セッター：state.isFromAdd */
        setIsFromAdd(state: any, isFromAdd: boolean) {
            state.isFromAdd = isFromAdd;
        },

        /** 
         * ユーザー管理ストアのクリア
         * 
         * @param state ステートオブジェクト
         */
        clearStoreState(state: any) {
            state.pageNation = 1;
            state.itemsPerPage = SystemConst.LIST_LINES_PER_PAGE[1];
            state.activeNode = [];
            state.openNode = [];
            state.searchMethod = SystemConst.USER_SEARCH_METHOD.ALL_USER;
            state.searchTree = '';
            state.filters = {};
            state.sortBy = [];
            state.sortDesc = [];
            state.isFromAdd = false;
        }
    },
    actions: {
        // 一覧表示用ユーザー情報取得API
        async getUsers({ state, commit, rootState }: any, data: any) {
            // 通信結果
            let result: any;

            // ユーザー一覧情報をback側から取得
            await axios.get('/api/users', {
                params: {
                    page : data.page,                           // 作成したページ番号パラメータ
                    itemsPerPage : data.itemsPerPage,           // 作成した1ページあたりの行数パラメータ
                    sortKey : data.sortKey,                     // 作成したソートキーパラメータ
                    sortOrder : data.sortOrder,                 // 作成したソート順パラメータ
                    filterParams : data.filterParams,           // 作成したフィルタ情報パラメータ
                    selectTreeId: data.selectTreeId,            // 組織ツリーの組織ID
                    selectTreeDivision: data.selectTreeDivision // 組織ツリーの組織区分
                }
            })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 組織ツリー情報取得API
        async getTree() {
            let result: any;

            // 組織ツリーをback側から取得
            await axios.get('/api/organization-tree')
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // ユーザー一覧フィルター情報取得API
        async getFilterConditions() {
            // resultの初期化
            let result: any;

            // フィルタ項目の条件を取得する
            await axios.get('/api/users/filter-conditions')
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信が失敗した場合、エラー結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // プルダウン情報(組織情報＋年度情報)取得API
        async getPullDowns() {
            // resultの初期化
            let result: any;

            // URL:GET /api/users/pull-downs
            await axios.get('/api/users/pull-downs', {
            })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信が失敗した場合、エラー結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // メールアドレス変更、ドメイン取得API
        async getMailAddress({ state, commit, rootState }: any, data: any) {
            // 通信結果格納用変数初期化
            let result: any;

            // メールアドレス、ドメイン情報をback側から取得
            await axios.get('/api/users/mail',
                {
                    params: {
                        // params: アドレス部, アカウント区分, 所属組織の組織ID, メール（選択）
                        englishCharsAddress: data.englishCharsAddress,
                        accountDivision: data.accountDivision,
                        organizationId: data.organizationId,
                        autoSetMail: data.autoSetMail,
                        userId: data.userId
                    }
                })
                .then((response) => {
                    // 正常時の通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // エラー時の通信結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // ユーザー登録API
        async addUser({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // ユーザー情報の登録をする
            // 識別コードの重複チェック、所属組織の存在チェック、メールアドレスチェック、パスワード一致のチェックも行う
            // URL:POST /api/users
            await axios.post('/api/users',
                {
                    // params: フォームの入力情報
                    user: data.user
                })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信が失敗した場合、エラー結果を設定
                    result = error.response;
                })

            // 通信結果を返す
            return result;
        },

        // Excel出力API
        async outputExcel({ state, commit, rootState }: any, data: any) {
            // Excelファイル名の格納
            const fileName = data.fileName;

            // resultの初期化
            let result: any;

            // URL:GET /api/users/excel
            // params:フィルタ・ソート情報
            //        組織ツリー情報
            //        一括登録用のファイルか
            await axios.get('/api/users/excel', {
                params: {
                    sortKey : data.sortKey,
                    sortOrder : data.sortOrder,
                    filterParams : data.filterParams,
                    selectTreeId: data.selectTreeId,
                    selectTreeDivision: data.selectTreeDivision,
                    isBulk: data.isBulk
                },
                // レスポンスのバイナリデータをarraybufferで受け取る
                responseType: 'arraybuffer'
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;

                    // レスポンス結果のバイナリデータが存在する場合、Excelファイルを作成する
                    if (response.data) {
                        // レスポンス結果のバイナリデータをBlobオブジェクトにする
                        const blob = new Blob([response.data]);

                        // BlobオブジェクトのURLオブジェクトを作成する
                        const objURL: string = window.URL.createObjectURL(blob);

                        // エレメントを作成し、要素にURLオブジェクトとダウンロードするファイル名を格納する
                        const dlLink: HTMLAnchorElement = document.createElement('a');
                        dlLink.href = objURL;
                        dlLink.download = fileName;

                        // 親のHTMLのbody要素に子ノードを追加し、作成した要素を追加する
                        document.body.appendChild(dlLink);

                        // 追加した子ノードの要素に対してクリックイベントを起こし、ファイルをダウンロードする
                        dlLink.click();

                        // 子ノードを削除する
                        document.body.removeChild(dlLink);
                    }
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                    // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                    const errorMessage = Array.from(new Uint8Array(error.response.data));

                    // 作成した文字コードを文字列に変換し、JSON形式に変換する
                    result.data =  JSON.parse(String.fromCharCode.apply("", errorMessage));
                });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        },

        // 編集/削除対象データ取得API
        async getOperateUser({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/users/{userId}
            //   userId: 編集/削除対象ユーザーID
            await axios.get(`/api/users/${data.userId}`)
                .then((response) => {
                    // 通信が成功した場合、通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信が失敗した場合、エラー結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // ユーザー編集API
        async updateUser({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:PUT /api/users/{userId}
            //   userId: 編集対象ユーザーID
            await axios.put(`/api/users/${data.userId}`,
                // params: 入力した編集データ
                {
                    user: data.user
                }
            )
                .then((response) => {
                    // 通信が成功した場合、通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信が失敗した場合、エラー結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // ユーザー削除API
        async deleteUser({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:DELETE /api/users/{userId}
            //    userId: 削除対象ユーザーID
            await axios.delete(`/api/users/${data.userId}`)
                .then((response) => {
                    // 通信が成功した場合、通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信が失敗した場合、エラー結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        }
    }
}
